// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"b52a0b28","787":"68cb9a1b","850":"84634282"}[chunkId] + ".chunk.js";
};